// @flow
import * as React from 'react';
import { withTheme } from 'styled-components';
import { Field, reduxForm } from 'redux-form';
import LoadingSpinner from 'common/components/LoadingSpinner';
import { translate } from 'react-i18next';

import { Form, STextField, ButtonSubmit } from '../styles';
import { resetPasswordValidator, passwordValidator, mapErrorCode } from '../domain/validations';

type ForgotPasswordValues = {
  password?: string,
  passwordValidation?: string,
};

const fieldsToValidate = ['password', 'passwordValidation'];

const validate = (fields: ForgotPasswordValues) => {
  const errors = {};

  let passwordValidation = passwordValidator(fields.password);
  if (!passwordValidation.isValid) {
    errors.password = mapErrorCode(passwordValidation.errorCode);
  }

  passwordValidation = passwordValidator(fields.passwordValidation);
  if (!passwordValidation.isValid) {
    errors.passwordValidation = mapErrorCode(passwordValidation.errorCode);
  }

  passwordValidation = resetPasswordValidator(fields.password, fields.passwordValidation);
  if (!passwordValidation.isValid) {
    errors.passwordValidation = mapErrorCode(passwordValidation.errorCode);
  }

  return errors;
};

type Props = {
  handleSubmit: Function,
  onSubmit: (fields: Object) => void,
  isResetting: boolean,
  theme: Object,
  t: any,
}

function ResetPasswordForm({ isResetting, onSubmit, handleSubmit, theme, t }: Props) {
  if (isResetting) {
    <LoadingSpinner size="large" style={{ marginTop: '3%' }} />;
  }

  return (
    <Form onSubmit={handleSubmit(onSubmit)}>
      <div style={theme.fonts.style.secondary}>{t('passwordChange')}</div>
      <Field component={STextField} name="password" type="password" floatingLabelText={t('password')} />
      <Field component={STextField} name="passwordValidation" type="password" floatingLabelText={t('passwordVerification')} />
      <ButtonSubmit type="submit" style={{ marginTop: theme.metrics.largeMargin }}>{t('change')}</ButtonSubmit>
    </Form>
  );
}

export default withTheme(translate('commonAuthentication')(reduxForm({
  form: 'ResetPassword',
  fields: fieldsToValidate,
  validate: validate,
})(ResetPasswordForm)));



// WEBPACK FOOTER //
// ./src/common/modules/authentication/resetPassword/ResetPasswordForm.js